export default (http) => ({
    login(login, password, appVersion) {
        return http.post(`/login`, { login, password, appVersion });
    },

    refreshToken(login, token) {
        return http.post(`/refresh-token`, { login, token });
    }
});
